import React, { SVGProps } from "react";
import Icon from "./Icon";
export * from "./SocialIcon";
export interface IconProps extends React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> {
  size?: number;
  height?: number;
  width?: number;
  color?: string;
  viewBox?: string;
  strokeWidth?: number;
  fill?: string;
}

// export const BookmarkIcon: React.FC<IconProps> = (props) => {
//   return (
//     <Icon {...props}></Icon>);
// }

export const EditIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M11.4922 2.78906H7.75324C4.67824 2.78906 2.75024 4.96606 2.75024 8.04806V16.3621C2.75024 19.4441 4.66924 21.6211 7.75324 21.6211H16.5772C19.6622 21.6211 21.5812 19.4441 21.5812 16.3621V12.3341"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.82763 10.9205L16.3006 3.4475C17.2316 2.5175 18.7406 2.5175 19.6716 3.4475L20.8886 4.6645C21.8196 5.5955 21.8196 7.1055 20.8886 8.0355L13.3796 15.5445C12.9726 15.9515 12.4206 16.1805 11.8446 16.1805H8.09863L8.19263 12.4005C8.20663 11.8445 8.43363 11.3145 8.82763 10.9205Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.165 4.60156L19.731 9.16756"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const CalendarIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M3.09253 9.4025H20.9165"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.442 13.3088H16.4512"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0047 13.3088H12.014"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.55793 13.3088H7.5672"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.442 17.1955H16.4512"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0047 17.1955H12.014"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.55793 17.1955H7.5672"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0438 2V5.29078"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9654 2V5.29078"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2383 3.57812H7.77096C4.83427 3.57812 3 5.21406 3 8.22115V17.2708C3 20.3252 4.83427 21.9989 7.77096 21.9989H16.229C19.175 21.9989 21 20.3535 21 17.3464V8.22115C21.0092 5.21406 19.1842 3.57812 16.2383 3.57812Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </Icon>
  );
};

export const ImageIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props} viewBox="0 0">
      <g id="Iconly/Light-Outline/Image 3">
        <g id="Image 2">
          <g id="Group 3">
            <mask
              id="mask0"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="2"
              y="2"
              width="24"
              height="24"
            >
              <path
                id="Clip 2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.00037 2.00012H21.9534V21.954H2.00037V2.00012Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                id="Fill 1"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.65137 3.5C5.13037 3.5 3.50037 5.229 3.50037 7.904V16.05C3.50037 18.726 5.13037 20.454 7.65137 20.454H16.2974C18.8224 20.454 20.4534 18.726 20.4534 16.05V7.904C20.4554 6.541 20.0394 5.403 19.2514 4.614C18.5234 3.885 17.5044 3.5 16.3024 3.5H7.65137ZM16.2974 21.954H7.65137C4.27137 21.954 2.00037 19.581 2.00037 16.05V7.904C2.00037 4.373 4.27137 2 7.65137 2H16.3024C17.9104 2 19.2974 2.537 20.3124 3.554C21.3734 4.616 21.9554 6.161 21.9534 7.905V16.05C21.9534 19.581 19.6804 21.954 16.2974 21.954Z"
                fill="black"
              />
            </g>
          </g>
          <path
            id="Fill 4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.85635 7.68958C8.25235 7.68958 7.76135 8.18058 7.76135 8.78558C7.76135 9.38958 8.25235 9.88058 8.85735 9.88058C9.46135 9.88058 9.95335 9.38958 9.95335 8.78658C9.95235 8.18158 9.46035 7.69058 8.85635 7.68958ZM8.85735 11.3806C7.42535 11.3806 6.26135 10.2166 6.26135 8.78558C6.26135 7.35358 7.42535 6.18958 8.85735 6.18958C10.2884 6.19058 11.4524 7.35458 11.4534 8.78458V8.78558C11.4534 10.2166 10.2894 11.3806 8.85735 11.3806Z"
            fill="black"
          />
          <path
            id="Fill 6"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.74893 20.1113C3.62493 20.1113 3.49893 20.0803 3.38293 20.0153C3.02093 19.8123 2.89393 19.3553 3.09593 18.9943C3.15593 18.8863 4.59093 16.3493 6.16993 15.0493C7.42193 14.0193 8.76993 14.5853 9.85593 15.0423C10.4949 15.3113 11.0989 15.5653 11.6789 15.5653C12.2109 15.5653 12.8779 14.6253 13.4679 13.7963C14.2869 12.6403 15.2169 11.3323 16.5789 11.3323C18.7489 11.3323 20.6219 13.2683 21.6289 14.3083L21.7449 14.4283C22.0329 14.7253 22.0259 15.2003 21.7289 15.4893C21.4339 15.7783 20.9589 15.7713 20.6689 15.4733L20.5509 15.3513C19.6989 14.4703 18.1129 12.8323 16.5789 12.8323C15.9909 12.8323 15.3009 13.8053 14.6899 14.6643C13.8519 15.8443 12.9849 17.0653 11.6789 17.0653C10.7959 17.0653 9.98693 16.7253 9.27393 16.4243C8.13993 15.9463 7.62593 15.7933 7.12293 16.2073C5.75893 17.3313 4.41693 19.7053 4.40393 19.7283C4.26693 19.9733 4.01193 20.1113 3.74893 20.1113Z"
            fill="black"
          />
        </g>
      </g>
    </Icon>
  );
};

export const BillIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <g>
        <g id="Document">
          <path
            id="Fill 1"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7158 16.9738H8.49585C8.08185 16.9738 7.74585 16.6378 7.74585 16.2238C7.74585 15.8098 8.08185 15.4738 8.49585 15.4738H15.7158C16.1298 15.4738 16.4658 15.8098 16.4658 16.2238C16.4658 16.6378 16.1298 16.9738 15.7158 16.9738Z"
            fill="black"
          />
          <path
            id="Fill 3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7158 12.7872H8.49585C8.08185 12.7872 7.74585 12.4512 7.74585 12.0372C7.74585 11.6232 8.08185 11.2872 8.49585 11.2872H15.7158C16.1298 11.2872 16.4658 11.6232 16.4658 12.0372C16.4658 12.4512 16.1298 12.7872 15.7158 12.7872Z"
            fill="black"
          />
          <path
            id="Fill 5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2506 8.61047H8.49561C8.08161 8.61047 7.74561 8.27447 7.74561 7.86047C7.74561 7.44647 8.08161 7.11047 8.49561 7.11047H11.2506C11.6646 7.11047 12.0006 7.44647 12.0006 7.86047C12.0006 8.27447 11.6646 8.61047 11.2506 8.61047Z"
            fill="black"
          />
          <g id="Group 9">
            <mask
              id="mask0"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="3"
              y="2"
              width="19"
              height="20"
            >
              <path
                id="Clip 8"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 2.00024H21.1647V21.91H3V2.00024Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                id="Fill 7"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.9088 3.5L8.21976 3.504C5.89176 3.518 4.49976 4.958 4.49976 7.357V16.553C4.49976 18.968 5.90476 20.41 8.25576 20.41L15.9448 20.407C18.2728 20.393 19.6648 18.951 19.6648 16.553V7.357C19.6648 4.942 18.2608 3.5 15.9088 3.5ZM8.25676 21.91C5.11276 21.91 2.99976 19.757 2.99976 16.553V7.357C2.99976 4.124 5.04676 2.023 8.21476 2.004L15.9078 2H15.9088C19.0528 2 21.1648 4.153 21.1648 7.357V16.553C21.1648 19.785 19.1178 21.887 15.9498 21.907L8.25676 21.91Z"
                fill="black"
              />
            </g>
          </g>
        </g>
      </g>
    </Icon>
  );
};

export const WalletIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <g id="Iconly/Light-Outline/Wallet">
        <g id="Wallet">
          <path
            id="Fill 1"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.8887 15.8955H17.8407C15.9437 15.8955 14.3997 14.3526 14.3987 12.4565C14.3987 10.5585 15.9427 9.01455 17.8407 9.01355H21.8887C22.3027 9.01355 22.6387 9.34955 22.6387 9.76355C22.6387 10.1775 22.3027 10.5135 21.8887 10.5135H17.8407C16.7697 10.5145 15.8987 11.3855 15.8987 12.4555C15.8987 13.5245 16.7707 14.3955 17.8407 14.3955H21.8887C22.3027 14.3955 22.6387 14.7315 22.6387 15.1455C22.6387 15.5595 22.3027 15.8955 21.8887 15.8955Z"
            fill="black"
          />
          <path
            id="Fill 3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.2983 13.1436H17.9863C17.5723 13.1436 17.2363 12.8076 17.2363 12.3936C17.2363 11.9796 17.5723 11.6436 17.9863 11.6436H18.2983C18.7123 11.6436 19.0483 11.9796 19.0483 12.3936C19.0483 12.8076 18.7123 13.1436 18.2983 13.1436Z"
            fill="black"
          />
          <g id="Group 7">
            <mask
              id="mask0"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="2"
              y="3"
              width="21"
              height="20"
            >
              <path
                id="Clip 6"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 3H22.6386V22.1729H2V3Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                id="Fill 5"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.99751 4.5C5.51751 4.5 3.49951 6.518 3.49951 8.998V16.175C3.49951 18.655 5.51751 20.673 7.99751 20.673H16.6415C19.1215 20.673 21.1385 18.655 21.1385 16.175V8.998C21.1385 6.518 19.1215 4.5 16.6415 4.5H7.99751ZM16.6415 22.173H7.99751C4.69051 22.173 1.99951 19.482 1.99951 16.175V8.998C1.99951 5.69 4.69051 3 7.99751 3H16.6415C19.9485 3 22.6385 5.69 22.6385 8.998V16.175C22.6385 19.482 19.9485 22.173 16.6415 22.173Z"
                fill="black"
              />
            </g>
          </g>
          <path
            id="Fill 8"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6846 9.03809H7.28564C6.87164 9.03809 6.53564 8.70209 6.53564 8.28809C6.53564 7.87409 6.87164 7.53809 7.28564 7.53809H12.6846C13.0986 7.53809 13.4346 7.87409 13.4346 8.28809C13.4346 8.70209 13.0986 9.03809 12.6846 9.03809Z"
            fill="black"
          />
        </g>
      </g>
    </Icon>
  );
};

export const DocumentIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <g id="Iconly/Light-Outline/Paper">
        <g id="Paper">
          <g id="Group 3">
            <mask
              id="mask0"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="3"
              y="2"
              width="18"
              height="20"
            >
              <path
                id="Clip 2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.00024 2.0116H20.0529V21.8651H3.00024V2.0116Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                id="Fill 1"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.57335 3.5116C5.91635 3.5116 4.54035 4.8536 4.50135 6.5086V17.2036C4.46435 18.9166 5.81435 20.3276 7.51035 20.3656H15.5743C17.2433 20.2966 18.5653 18.9096 18.5533 17.2096V8.3396L13.9183 3.5116H7.58535H7.57335ZM7.58535 21.8656H7.47635C4.95435 21.8086 2.94635 19.7106 3.00135 17.1876V6.4906C3.05935 4.0096 5.10835 2.0116 7.57135 2.0116H7.58835H14.2383C14.4423 2.0116 14.6373 2.0946 14.7793 2.2416L19.8443 7.5186C19.9783 7.6576 20.0533 7.8446 20.0533 8.0376V17.2036C20.0713 19.7126 18.1173 21.7626 15.6043 21.8646L7.58535 21.8656Z"
                fill="black"
              />
            </g>
          </g>
          <path
            id="Fill 4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.2985 8.98424H16.5435C14.7135 8.97924 13.2255 7.48724 13.2255 5.65924V2.75024C13.2255 2.33624 13.5615 2.00024 13.9755 2.00024C14.3895 2.00024 14.7255 2.33624 14.7255 2.75024V5.65924C14.7255 6.66324 15.5425 7.48124 16.5455 7.48424H19.2985C19.7125 7.48424 20.0485 7.82024 20.0485 8.23424C20.0485 8.64824 19.7125 8.98424 19.2985 8.98424Z"
            fill="black"
          />
          <path
            id="Fill 6"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.7887 16.1084H8.38867C7.97467 16.1084 7.63867 15.7724 7.63867 15.3584C7.63867 14.9444 7.97467 14.6084 8.38867 14.6084H13.7887C14.2027 14.6084 14.5387 14.9444 14.5387 15.3584C14.5387 15.7724 14.2027 16.1084 13.7887 16.1084Z"
            fill="black"
          />
          <path
            id="Fill 8"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.7437 12.3563H8.3877C7.9737 12.3563 7.6377 12.0203 7.6377 11.6063C7.6377 11.1923 7.9737 10.8563 8.3877 10.8563H11.7437C12.1577 10.8563 12.4937 11.1923 12.4937 11.6063C12.4937 12.0203 12.1577 12.3563 11.7437 12.3563Z"
            fill="black"
          />
        </g>
      </g>
    </Icon>
  );
};

export const PageIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M14 5.33203V13.994C14.0006 14.0816 13.984 14.1684 13.951 14.2495C13.9181 14.3306 13.8695 14.4045 13.808 14.4668C13.7466 14.5291 13.6734 14.5788 13.5928 14.6128C13.5121 14.6469 13.4255 14.6648 13.338 14.6654H2.662C2.48654 14.6654 2.31826 14.5957 2.19413 14.4717C2.07 14.3477 2.00018 14.1795 2 14.004V1.99336C2 1.63536 2.29933 1.33203 2.668 1.33203H9.998L14 5.33203ZM12.6667 5.9987H9.33333V2.66536H3.33333V13.332H12.6667V5.9987ZM5.33333 4.66536H7.33333V5.9987H5.33333V4.66536ZM5.33333 7.33203H10.6667V8.66536H5.33333V7.33203ZM5.33333 9.9987H10.6667V11.332H5.33333V9.9987Z"
        fill="#137ACD"
      />
    </Icon>
  );
};

export const CaretDownIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M12 16.8L4.8 9.60001H19.2L12 16.8Z" fill="#445668" />
    </Icon>
  );
};

export const UpvoteIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#687F80"
      />
      <path
        d="M12 9L17 14L16.3 14.7L12 10.4L7.7 14.7L7 14L12 9Z"
        fill="#687F80"
      />
    </Icon>
  );
};

export const ChevronDownIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M8 12L16 20L24 12"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const ChevronRightIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M9.31002 6.70978C9.21732 6.80229 9.14377 6.91218 9.09359 7.03315C9.04341 7.15413 9.01758 7.28381 9.01758 7.41478C9.01758 7.54575 9.04341 7.67543 9.09359 7.7964C9.14377 7.91738 9.21732 8.02726 9.31002 8.11978L13.19 11.9998L9.31002 15.8798C9.12304 16.0668 9.018 16.3204 9.018 16.5848C9.018 16.8492 9.12304 17.1028 9.31002 17.2898C9.497 17.4768 9.7506 17.5818 10.015 17.5818C10.2794 17.5818 10.533 17.4768 10.72 17.2898L15.31 12.6998C15.4027 12.6073 15.4763 12.4974 15.5265 12.3764C15.5766 12.2554 15.6025 12.1257 15.6025 11.9948C15.6025 11.8638 15.5766 11.7341 15.5265 11.6132C15.4763 11.4922 15.4027 11.3823 15.31 11.2898L10.72 6.69978C10.34 6.31978 9.70002 6.31978 9.31002 6.70978Z"
        fill="#91A4B7"
      />
    </Icon>
  );
};

export const UploadImage: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props} height={7.5} width={7.5}>
      <path
        d="M9.16602 12.5H10.8327V7.5H13.3327L9.99935 3.33333L6.66602 7.5H9.16602V12.5Z"
        fill="#244DEA"
      />
      <path
        d="M16.666 15H3.33268V9.16667H1.66602V15C1.66602 15.9192 2.41352 16.6667 3.33268 16.6667H16.666C17.5852 16.6667 18.3327 15.9192 18.3327 15V9.16667H16.666V15Z"
        fill="#244DEA"
      />
    </Icon>
  );
};

export const EmailIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V13C0 13.7956 0.316071 14.5587 0.87868 15.1213C1.44129 15.6839 2.20435 16 3 16H17C17.7956 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7956 20 13V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM17 2L10.5 6.47C10.348 6.55777 10.1755 6.60397 10 6.60397C9.82446 6.60397 9.65202 6.55777 9.5 6.47L3 2H17Z" />
    </Icon>
  );
};

export const SecureIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M11.4879 21.754C11.7819 21.911 12.1509 21.91 12.4449 21.753C20.4569 17.449 21.0259 9.03998 21.0189 6.64898C21.0181 6.45681 20.9614 6.26904 20.8555 6.10865C20.7496 5.94826 20.5993 5.82223 20.4229 5.74598L12.3729 2.17998C12.2448 2.12351 12.1063 2.09443 11.9663 2.09461C11.8263 2.09478 11.6879 2.1242 11.5599 2.18098L3.56591 5.74698C3.3921 5.82327 3.24389 5.94791 3.13893 6.10606C3.03397 6.26421 2.97669 6.4492 2.97391 6.63898C2.93991 9.01798 3.41891 17.445 11.4879 21.754ZM8.67391 10.293L10.9669 12.586L15.2599 8.29298L16.6739 9.70698L10.9669 15.414L7.25991 11.707L8.67391 10.293Z"
        fill="white"
      />
    </Icon>
  );
};

export const InfoIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M8.00065 1.33333C4.32065 1.33333 1.33398 4.32 1.33398 8C1.33398 11.68 4.32065 14.6667 8.00065 14.6667C11.6807 14.6667 14.6673 11.68 14.6673 8C14.6673 4.32 11.6807 1.33333 8.00065 1.33333ZM8.66732 11.3333H7.33399V7.33333H8.66732V11.3333ZM8.66732 6H7.33399V4.66667H8.66732V6Z"
        fill="none"
      />
    </Icon>
  );
};

export const NotificationIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M10.0007 19.333C10.9173 19.333 11.6673 18.583 11.6673 17.6663H8.33398C8.33398 18.583 9.07565 19.333 10.0007 19.333ZM15.0007 14.333V10.1663C15.0007 7.60801 13.634 5.46634 11.2507 4.89967V4.33301C11.2507 3.64134 10.6923 3.08301 10.0007 3.08301C9.30898 3.08301 8.75065 3.64134 8.75065 4.33301V4.89967C6.35898 5.46634 5.00065 7.59967 5.00065 10.1663V14.333L3.33398 15.9997V16.833H16.6673V15.9997L15.0007 14.333Z"
        fill="#E1E8F0"
      />
      <circle cx="15" cy="5" r="5" fill="url(#paint0_linear)" />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="10"
          y1="0"
          x2="20"
          y2="11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2837" />
          <stop offset="1" stopColor="#BC1622" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const ActivityIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <polyline
        points="22 12 18 12 15 21 9 3 6 12 2 12"
        fill="none"
        strokeWidth={"1.5"}
      ></polyline>
    </Icon>
  );
};

export const NepalFlagIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <g clipPath="url(#clip0)">
        <path
          d="M0.751804 5.19734L9.32466 11.4621H3.92373H2.71896L3.52314 12.3592L9.76768 19.3242H0.751804V5.19734ZM0.358289 4.24353C0.27143 4.31942 0.213867 4.42742 0.213867 4.55173V19.4483C0.213867 19.6768 0.399164 19.8621 0.627679 19.8621H10.9725L3.92373 12H10.9725L0.358289 4.24353Z"
          fill="#41479B"
        />
        <path
          d="M0.752441 5.19733L9.3253 11.4621H3.92437H2.71959L3.52387 12.3591L9.76836 19.3241H0.752441V5.19733Z"
          fill="#FF4B55"
        />
        <path
          d="M3.37064 13.8937L3.70186 14.5773L4.3305 14.1509C4.35821 14.132 4.39547 14.1536 4.39303 14.187L4.33814 14.9446L5.09574 14.8897C5.12916 14.8872 5.15067 14.9245 5.13183 14.9522L4.70545 15.5808L5.38903 15.9121C5.41917 15.9267 5.41917 15.9696 5.38903 15.9843L4.70545 16.3155L5.13183 16.9441C5.15067 16.9718 5.12916 17.0091 5.09574 17.0066L4.33814 16.9518L4.39303 17.7093C4.39547 17.7428 4.35821 17.7643 4.3305 17.7454L3.70186 17.3191L3.37064 18.0026C3.35602 18.0328 3.31308 18.0328 3.29846 18.0026L2.96724 17.3191L2.3386 17.7454C2.3109 17.7643 2.27363 17.7428 2.27607 17.7093L2.33096 16.9518L1.57337 17.0066C1.53994 17.0091 1.51843 16.9718 1.53727 16.9441L1.96365 16.3155L1.27993 15.9844C1.24979 15.9698 1.24979 15.9268 1.27993 15.9122L1.96351 15.581L1.53713 14.9524C1.51829 14.9246 1.5398 14.8874 1.57323 14.8898L2.33082 14.9447L2.27593 14.1871C2.27349 14.1537 2.31076 14.1322 2.33846 14.151L2.9671 14.5774L3.29832 13.8938C3.31304 13.8635 3.35602 13.8635 3.37064 13.8937Z"
          fill="#F0F5F9"
        />
        <path
          d="M4.23045 9.94041L3.94287 9.74396L4.19604 9.4786L3.83524 9.41274L3.95862 9.06742L3.60223 9.15399L3.57443 8.78837L3.28409 9.01238L3.11004 8.6897L2.93595 9.01248L2.64561 8.78846L2.61781 9.15409L2.26142 9.06751L2.38479 9.41284L2.024 9.4787L2.27717 9.74405L1.98959 9.94051C1.62673 9.7711 1.3077 9.52355 1.05664 9.21737C1.2253 10.1999 2.07922 10.9484 3.10995 10.9484C4.14068 10.9484 4.99456 10.1999 5.16326 9.21737C4.91234 9.52351 4.59326 9.77101 4.23045 9.94041Z"
          fill="#F0F5F9"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="24"
            height="24"
            fill="none"
            transform="translate(0.213867)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};
export const DropdownIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M9.99962 10.9767L14.1246 6.85168L15.303 8.03002L9.99962 13.3334L4.69629 8.03002L5.87462 6.85168L9.99962 10.9767Z" />
    </Icon>
  );
};

export const UserIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M7.5 6.5C7.5 8.981 9.519 11 12 11C14.481 11 16.5 8.981 16.5 6.5C16.5 4.019 14.481 2 12 2C9.519 2 7.5 4.019 7.5 6.5ZM20 21H21V20C21 16.141 17.859 13 14 13H10C6.14 13 3 16.141 3 20V21H20Z"
        fill="white"
      />
    </Icon>
  );
};

export const SecurityIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M20.5677 17.325L20.9217 19.8C20.9435 19.9536 20.9294 20.1102 20.8803 20.2574C20.8312 20.4046 20.7485 20.5384 20.6387 20.6481C20.529 20.7578 20.3953 20.8405 20.2481 20.8896C20.1009 20.9387 19.9443 20.9529 19.7907 20.931L17.3157 20.577C16.9407 20.524 16.0007 18 16.0007 18C16.0007 18 15.5287 18.405 15.3357 18.466C14.9237 18.596 14.5227 18.192 14.3877 17.782L14.0007 16.01C14.0007 16.01 13.4237 16.302 13.2147 16.345C12.9487 16.4 12.6907 16.236 12.5077 16.052C12.3977 15.9424 12.3152 15.8085 12.2667 15.661L12.0007 14.01C12.0007 14.01 11.3257 14.197 11.0947 14.224C10.8317 14.254 10.5757 14.12 10.3877 13.931L9.24965 12.794C8.28635 13.1062 7.25559 13.1464 6.27087 12.9103C5.28616 12.6743 4.3857 12.171 3.66865 11.456C2.63897 10.4237 2.06072 9.02508 2.06072 7.567C2.06072 6.10892 2.63897 4.71035 3.66865 3.678C4.701 2.64832 6.09957 2.07007 7.55765 2.07007C9.01573 2.07007 10.4143 2.64832 11.4467 3.678C12.1618 4.39493 12.6652 5.29539 12.9013 6.28014C13.1374 7.2649 13.097 8.29572 12.7847 9.259L20.2857 16.759C20.4388 16.9119 20.5378 17.1107 20.5677 17.325ZM5.49665 5.506C4.95109 6.05317 4.64474 6.79432 4.64474 7.567C4.64474 8.33968 4.95109 9.08083 5.49665 9.628L9.61865 5.506C9.07148 4.96044 8.33033 4.65409 7.55765 4.65409C6.78497 4.65409 6.04382 4.96044 5.49665 5.506Z"
        fill="white"
      />
    </Icon>
  );
};

export const UserDetailIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M20 4H4C2.897 4 2 4.897 2 6V18C2 19.103 2.897 20 4 20H20C21.103 20 22 19.103 22 18V6C22 4.897 21.103 4 20 4ZM8.715 8C9.866 8 10.715 8.849 10.715 10C10.715 11.151 9.866 12 8.715 12C7.564 12 6.715 11.151 6.715 10C6.715 8.849 7.563 8 8.715 8ZM12.43 16H5V15.535C5 14.162 6.676 12.75 8.715 12.75C10.754 12.75 12.43 14.162 12.43 15.535V16ZM19 15H15V13H19V15ZM19 11H14V9H19V11Z"
        fill="white"
      />
    </Icon>
  );
};

export const EyeIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M10.214 3.75C6.04736 3.75 2.48903 6.34167 1.04736 10C2.48903 13.6583 6.04736 16.25 10.214 16.25C14.3807 16.25 17.939 13.6583 19.3807 10C17.939 6.34167 14.3807 3.75 10.214 3.75ZM10.214 14.1667C7.91403 14.1667 6.04736 12.3 6.04736 10C6.04736 7.7 7.91403 5.83333 10.214 5.83333C12.514 5.83333 14.3807 7.7 14.3807 10C14.3807 12.3 12.514 14.1667 10.214 14.1667ZM10.214 7.5C8.8307 7.5 7.71403 8.61667 7.71403 10C7.71403 11.3833 8.8307 12.5 10.214 12.5C11.5974 12.5 12.714 11.3833 12.714 10C12.714 8.61667 11.5974 7.5 10.214 7.5Z"
        fill={props.fill}
      />
    </Icon>
  );
};

export const ErrorIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M11.953 2C6.465 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.493 2 11.953 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
        fill="#FF2837"
      />
    </Icon>
  );
};

export const EllipseIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <rect
        x="0.25"
        y="0.25"
        width="31.5"
        height="23.5"
        rx="7.75"
        fill="#F0F5F9"
        stroke="#91A4B7"
        strokeWidth="0.5"
      />
      <path
        d="M15.9997 13.6666C16.9201 13.6666 17.6663 12.9205 17.6663 12C17.6663 11.0795 16.9201 10.3333 15.9997 10.3333C15.0792 10.3333 14.333 11.0795 14.333 12C14.333 12.9205 15.0792 13.6666 15.9997 13.6666Z"
        fill="currentColor"
      />
      <path
        d="M21.8337 13.6666C22.7541 13.6666 23.5003 12.9205 23.5003 12C23.5003 11.0795 22.7541 10.3333 21.8337 10.3333C20.9132 10.3333 20.167 11.0795 20.167 12C20.167 12.9205 20.9132 13.6666 21.8337 13.6666Z"
        fill="currentColor"
      />
      <path
        d="M10.1667 13.6666C11.0871 13.6666 11.8333 12.9205 11.8333 12C11.8333 11.0795 11.0871 10.3333 10.1667 10.3333C9.24619 10.3333 8.5 11.0795 8.5 12C8.5 12.9205 9.24619 13.6666 10.1667 13.6666Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export const CloseIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 18L18 6M6 6l12 12"
      />
    </Icon>
  );
};
export const SearchIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        stroke="none"
        d="M 8.71875 16.921875 C 10.539062 16.921875 12.304688 16.3125 13.738281 15.191406 L 18.25 19.699219 L 19.699219 18.25 L 15.191406 13.742188 C 16.3125 12.308594 16.921875 10.539062 16.921875 8.71875 C 16.921875 4.195312 13.242188 0.511719 8.71875 0.511719 C 4.191406 0.511719 0.511719 4.195312 0.511719 8.71875 C 0.511719 13.242188 4.191406 16.921875 8.71875 16.921875 Z M 8.71875 2.5625 C 12.109375 2.5625 14.871094 5.324219 14.871094 8.71875 C 14.871094 12.113281 12.109375 14.871094 8.71875 14.871094 C 5.324219 14.871094 2.5625 12.113281 2.5625 8.71875 C 2.5625 5.324219 5.324219 2.5625 8.71875 2.5625 Z M 8.71875 2.5625 "
      />
    </Icon>
  );
};

export const TickIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        stroke="none"
        d="M11.037 18.3788L5.36328 13.9587L6.97653 11.8883L10.4607 14.6026L16.2109 6.30493L18.3687 7.79968L11.037 18.3788Z"
        fill="current"
      />
    </Icon>
  );
};

export const BarGraphIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M6.14292 8.50195V14.2187"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0316 5.7666V14.2189"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8558 11.5225V14.2183"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9041 1.66699H6.09459C3.37236 1.66699 1.66602 3.59373 1.66602 6.32129V13.6794C1.66602 16.4069 3.36443 18.3337 6.09459 18.3337H13.9041C16.6343 18.3337 18.3327 16.4069 18.3327 13.6794V6.32129C18.3327 3.59373 16.6343 1.66699 13.9041 1.66699Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </Icon>
  );
};

export const LineChartIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M6.03711 12.3183L8.53139 9.07646L11.3765 11.3114L13.8174 8.16113"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="16.6624"
        cy="3.50027"
        r="1.60183"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M12.4365 2.60059H6.38005C3.87052 2.60059 2.31445 4.37786 2.31445 6.88739V13.6227C2.31445 16.1322 3.84001 17.9019 6.38005 17.9019H13.5502C16.0597 17.9019 17.6158 16.1322 17.6158 13.6227V7.75696"
        fill="transparent"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const BookIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M11.7474 0V11.4907L1.50464 12.6084L0.25 12.7454V1.25464C0.25 0.908168 0.390273 0.594371 0.617336 0.367309C0.844398 0.140246 1.15817 0 1.50464 0L11.7474 0Z"
        fill="#DA4A54"
      />
      <path
        d="M1.50464 0V12.6084L0.25 12.7454V1.25464C0.25 0.908168 0.390273 0.594371 0.617336 0.367309C0.844398 0.140246 1.15817 0 1.50464 0V0Z"
        fill="#C32430"
      />
      <path
        d="M11.7475 11.4902H1.50459C0.811695 11.4902 0.25 12.0519 0.25 12.7448C0.25 13.4377 0.811695 13.9994 1.50459 13.9994H11.7475V13.2952L11.2371 12.7448L11.7475 12.1944V11.4902Z"
        fill="#C32430"
      />
      <path
        d="M1.50545 13.2961C1.20196 13.2961 0.955078 13.0492 0.955078 12.7457C0.955078 12.4422 1.20196 12.1953 1.50545 12.1953H11.7484V13.2961H1.50545Z"
        fill="#DFEAEF"
      />
      <path
        d="M4.76746 2.72018L3.85541 1.7841L2.94336 2.72018V0H4.76746V2.72018Z"
        fill="#F4DD45"
      />
      <path
        d="M8.74475 3.50684H3.881C3.39336 3.50684 2.99805 3.90214 2.99805 4.38979V7.084C2.99805 7.57165 3.39336 7.96696 3.881 7.96696H8.74475C9.2324 7.96696 9.62771 7.57165 9.62771 7.084V4.38979C9.62771 3.90214 9.2324 3.50684 8.74475 3.50684Z"
        fill="#DFEAEF"
      />
      <path
        d="M8.74509 8.17856H3.88135C3.27798 8.17856 2.78711 7.68769 2.78711 7.08432V4.39011C2.78711 3.78677 3.27798 3.2959 3.88135 3.2959H8.74509C9.34846 3.2959 9.83934 3.78677 9.83934 4.39011V7.08432C9.83934 7.68769 9.34846 8.17856 8.74509 8.17856ZM3.88135 3.71844C3.51098 3.71844 3.20965 4.01977 3.20965 4.39011V7.08432C3.20965 7.45469 3.51098 7.75602 3.88135 7.75602H8.74509C9.11547 7.75602 9.41679 7.45469 9.41679 7.08432V4.39011C9.41679 4.01974 9.11547 3.71844 8.74509 3.71844H3.88135Z"
        fill="#C32430"
      />
      <path
        d="M8.29717 5.38834H4.32844C4.21177 5.38834 4.11719 5.29375 4.11719 5.17708C4.11719 5.0604 4.21177 4.96582 4.32844 4.96582H8.29714C8.41381 4.96582 8.5084 5.0604 8.5084 5.17708C8.50842 5.29375 8.41384 5.38834 8.29717 5.38834Z"
        fill="#665E66"
      />
      <path
        d="M8.29717 6.50845H4.32844C4.21177 6.50845 4.11719 6.41387 4.11719 6.2972C4.11719 6.18052 4.21177 6.08594 4.32844 6.08594H8.29714C8.41381 6.08594 8.5084 6.18052 8.5084 6.2972C8.5084 6.41387 8.41384 6.50845 8.29717 6.50845Z"
        fill="#665E66"
      />
    </Icon>
  );
};

export const CalenderColorIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M0.46875 11.2002V13.0669C0.46875 13.5823 0.886609 14.0002 1.40207 14.0002H12.6021C13.1175 14.0002 13.5354 13.5823 13.5354 13.0669V11.2002H0.46875Z"
        fill="#B5DBFF"
      />
      <path
        d="M12.8864 11.2002V13.0669C12.8864 13.5823 12.4686 14.0002 11.9531 14.0002H12.601C13.1165 14.0002 13.5343 13.5823 13.5343 13.0669V11.2002H12.8864Z"
        fill="#97D0FF"
      />
      <path
        d="M0.46875 3.7334V12.1334C0.46875 12.6488 0.886609 13.0667 1.40205 13.0667H12.6021C13.1175 13.0667 13.5354 12.6488 13.5354 12.1334V3.7334H0.46875Z"
        fill="#EDF5FF"
      />
      <path
        d="M12.8864 3.7334V12.1334C12.8864 12.6488 12.4686 13.0667 11.9531 13.0667H12.601C13.1165 13.0667 13.5343 12.6488 13.5343 12.1334V3.7334H12.8864Z"
        fill="#D5E8FE"
      />
      <path
        d="M13.5354 4.20025V1.86689C13.5354 1.35143 13.1175 0.933594 12.6021 0.933594H1.40205C0.886581 0.933594 0.46875 1.35145 0.46875 1.86689V4.20025H13.5354Z"
        fill="#FF435B"
      />
      <path
        d="M3.27169 2.07781H2.80502C2.68834 2.07781 2.59375 1.98322 2.59375 1.86654C2.59375 1.74987 2.68834 1.65527 2.80502 1.65527H3.27169C3.38837 1.65527 3.48296 1.74987 3.48296 1.86654C3.48296 1.98322 3.38837 2.07781 3.27169 2.07781Z"
        fill="#E3374E"
      />
      <path
        d="M4.66622 2.07781H4.19955C4.08287 2.07781 3.98828 1.98322 3.98828 1.86654C3.98828 1.74987 4.08287 1.65527 4.19955 1.65527H4.66619C4.78287 1.65527 4.87746 1.74987 4.87746 1.86654C4.87746 1.98322 4.7829 2.07781 4.66622 2.07781Z"
        fill="#E3374E"
      />
      <path
        d="M9.80291 2.07781H9.33627C9.21959 2.07781 9.125 1.98322 9.125 1.86654C9.125 1.74987 9.21959 1.65527 9.33627 1.65527H9.80291C9.91959 1.65527 10.0142 1.74987 10.0142 1.86654C10.0142 1.98322 9.91959 2.07781 9.80291 2.07781Z"
        fill="#E3374E"
      />
      <path
        d="M11.2053 2.07781H10.7386C10.6219 2.07781 10.5273 1.98322 10.5273 1.86654C10.5273 1.74987 10.6219 1.65527 10.7386 1.65527H11.2053C11.322 1.65527 11.4166 1.74987 11.4166 1.86654C11.4166 1.98322 11.322 2.07781 11.2053 2.07781Z"
        fill="#E3374E"
      />
      <path
        d="M3.26956 1.86668C3.26956 2.12439 3.47849 2.33335 3.73624 2.33335C3.99398 2.33335 4.20292 2.12442 4.20292 1.86668V0.466676C4.20289 0.20893 3.99396 0 3.73621 0C3.47849 0 3.26953 0.20893 3.26953 0.466676V1.86668H3.26956Z"
        fill="#596C76"
      />
      <path
        d="M9.80469 1.86668C9.80469 2.12439 10.0136 2.33335 10.2714 2.33335C10.5291 2.33335 10.738 2.12442 10.738 1.86668V0.466676C10.738 0.20893 10.5291 0 10.2714 0C10.0136 0 9.80469 0.20893 9.80469 0.466676V1.86668Z"
        fill="#596C76"
      />
      <path
        d="M12.601 0.933594H11.9531C12.4686 0.933594 12.8864 1.35145 12.8864 1.86689V4.20028H13.5343V1.86692C13.5343 1.35145 13.1165 0.933594 12.601 0.933594Z"
        fill="#E3374E"
      />
      <path
        d="M0.46875 3.05566H13.5354V3.4782H0.46875V3.05566Z"
        fill="#E3374E"
      />
      <path
        d="M7.23829 7.35058C7.23829 6.38563 6.45324 5.60059 5.48828 5.60059C4.52333 5.60059 3.73828 6.38563 3.73828 7.35058C3.73828 7.60833 3.94721 7.81726 4.20496 7.81726C4.46271 7.81726 4.67164 7.60833 4.67164 7.35058C4.67164 6.90027 5.03797 6.53391 5.48831 6.53391C5.93862 6.53391 6.30499 6.90024 6.30499 7.35058C6.30499 7.80092 5.93865 8.16725 5.48831 8.16725C5.23057 8.16725 5.02164 8.37618 5.02164 8.63393C5.02164 8.89168 5.23057 9.1006 5.48831 9.1006C5.93862 9.1006 6.30499 9.46694 6.30499 9.91728C6.30499 10.3676 5.93865 10.734 5.48831 10.734C5.038 10.734 4.67164 10.3676 4.67164 9.91728C4.67164 9.65953 4.46271 9.4506 4.20496 9.4506C3.94721 9.4506 3.73828 9.65953 3.73828 9.91728C3.73828 10.8822 4.52333 11.6673 5.48828 11.6673C6.45324 11.6673 7.23829 10.8822 7.23829 9.91728C7.23829 9.41063 7.02164 8.95382 6.6764 8.63396C7.02167 8.31404 7.23829 7.85723 7.23829 7.35058Z"
        fill="#596C76"
      />
      <path
        d="M9.48093 5.63516C9.30654 5.56288 9.1058 5.60288 8.97237 5.73635L8.03903 6.66967C7.85678 6.85189 7.85678 7.14738 8.03903 7.32961C8.22126 7.51183 8.51676 7.51183 8.69898 7.32961L8.83569 7.1929V11.1996C8.83569 11.4574 9.04462 11.6663 9.30237 11.6663C9.56012 11.6663 9.76905 11.4574 9.76905 11.1996V6.06632C9.76902 5.87756 9.6553 5.70739 9.48093 5.63516Z"
        fill="#596C76"
      />
    </Icon>
  );
};

export * from "./SocialIcon";
export * from "./SVGImages";
export * from "./Logo";
